import { Label } from 'semantic-ui-react';

import { darkReaderIgnoreInlineStyleClass } from '@components/dark-mode/dark-mode-provider';

import s from '../../../json-field-editor.scss';
import type { BannerPreviewProps } from '../types';

/**
 * Banner preview component to show what the banners will look like
 */
const BannerPreview = ({ formData }: BannerPreviewProps) => {
  if (!formData || typeof formData !== 'object') return null;

  const { top, bottom } = formData;

  const hasTopBanner = top?.text?.trim() && top?.display;
  const hasBottomBanner = bottom?.text?.trim() && bottom?.display;

  if (!hasTopBanner && !hasBottomBanner) return null;

  return (
    <div className={s.bannerPreview}>
      <h4 className={s.bannerPreviewTitle}>Preview</h4>

      {hasTopBanner && (
        <div
          className={`${s.bannerPreviewItem} ${darkReaderIgnoreInlineStyleClass}`}
          style={{
            backgroundColor: top.background_color || '#0e40c0',
            color: top.text_color || '#fff',
          }}
        >
          <Label attached="top" size="small">
            Top Banner{top.display === 'login-only' ? '—Login View Only' : ''}
          </Label>
          <div>{top.text}</div>
        </div>
      )}

      {hasBottomBanner && (
        <div
          className={`${s.bannerPreviewItem} ${darkReaderIgnoreInlineStyleClass}`}
          style={{
            backgroundColor: bottom.background_color || '#0e40c0',
            color: bottom.text_color || '#fff',
          }}
        >
          <Label attached="top" size="small">
            Bottom Banner
            {bottom.display === 'login-only' ? '—Login View Only' : ''}
          </Label>
          <div>{bottom.text}</div>
        </div>
      )}
    </div>
  );
};

export default BannerPreview;
